import React, { useMemo } from 'react';
import { FormattedMessage } from 'translate';
import PropTypes from 'prop-types';

const TargetAudience = ({
  gender, minAge, maxAge, countries, enumsCountries,
}) => {
  const showGender = useMemo(() => {
    let genderText;
    switch (gender) {
    case 'male':
      genderText = (
        <FormattedMessage
          id="campaign_pay_it_forward.target_gender.male"
        />
      );
      break;
    case 'female':
      genderText = (
        <FormattedMessage
          id="campaign_pay_it_forward.target_gender.female"
        />
      );
      break;
    default:
      genderText = (
        <FormattedMessage
          id="campaign_pay_it_forward.target_gender.any"
        />
      );
    }

    return <span className="gender-capital-letter">{genderText}</span>;
  }, [gender]);

  const showTargetAudience = useMemo(
    () => {
      const isCountriesEmpty = !countries || countries.isEmpty()
        || countries.includes('GLOBAL') || countries.includes('global');
      const renderCountry = () => countries.toJS().map(country => enumsCountries[country]).join(', ');

      const defaultAge = minAge === 18 && maxAge === 100;

      if (gender && minAge && maxAge && !isCountriesEmpty && !defaultAge) {
        return (
          <FormattedMessage
            id="campaign_pay_it_forward.target_audience_all"
            values={{
              gender: showGender,
              minAge,
              maxAge,
              countries: renderCountry(),
            }}
          />
        );
      } else if (gender && minAge && !isCountriesEmpty && !defaultAge) {
        return (
          <FormattedMessage
            id="campaign_pay_it_forward.target_audience_gender_min-age_countries"
            values={{
              gender: showGender,
              minAge,
              countries: renderCountry(),
            }}
          />);
      } else if (gender && maxAge && !isCountriesEmpty && !defaultAge) {
        return (
          <FormattedMessage
            id="campaign_pay_it_forward.target_audience_gender_max-age_countries"
            values={{
              gender: showGender,
              maxAge,
              countries: renderCountry(),
            }}
          />
        );
      } else if (gender && !isCountriesEmpty) {
        return (
          <FormattedMessage
            id="campaign_pay_it_forward.target_audience_gender_countries"
            values={{
              gender: showGender,
              countries: renderCountry(),
            }}
          />
        );
      } else if (gender && (minAge || maxAge) && !defaultAge) {
        if (!minAge) {
          return (
            <FormattedMessage
              id="campaign_pay_it_forward.target_audience_gender_max-age"
              values={{
                gender: showGender,
                maxAge,
              }}
            />
          );
        } else if (!maxAge) {
          return (
            <FormattedMessage
              id="campaign_pay_it_forward.target_audience_gender_min-age"
              values={{
                gender: showGender,
                minAge,
              }}
            />
          );
        }
        return (
          <FormattedMessage
            id="campaign_pay_it_forward.target_audience_gender_age"
            values={{
              gender: showGender,
              minAge,
              maxAge,
            }}
          />
        );
      } else if ((minAge || maxAge) && !isCountriesEmpty && !defaultAge) {
        if (!minAge) {
          return (
            <FormattedMessage
              id="campaign_pay_it_forward.target_audience_countries_max-age"
              values={{
                countries: renderCountry(),
                maxAge,
              }}
            />
          );
        } else if (!maxAge) {
          return (
            <FormattedMessage
              id="campaign_pay_it_forward.target_audience_countries_min-age"
              values={{
                countries: renderCountry(),
                minAge,
              }}
            />
          );
        }
        return (
          <FormattedMessage
            id="campaign_pay_it_forward.target_audience_countries_age"
            values={{
              countries: renderCountry(),
              minAge,
              maxAge,
            }}
          />
        );
      } else if (gender) {
        return (
          <FormattedMessage
            id="campaign_pay_it_forward.target_audience_gender"
            values={{ gender: showGender }}
          />
        );
      } else if (!isCountriesEmpty) {
        return (
          <FormattedMessage
            id="campaign_pay_it_forward.target_audience_countries"
            values={{ countries: renderCountry() }}
          />
        );
      } else if ((minAge || maxAge) && !defaultAge) {
        if (!minAge) {
          return (
            <FormattedMessage
              id="campaign_pay_it_forward.target_audience_max-age"
              values={{ maxAge }}
            />
          );
        } else if (!maxAge) {
          return (
            <FormattedMessage
              id="campaign_pay_it_forward.target_audience_min-age"
              values={{ minAge }}
            />
          );
        }
        return (
          <FormattedMessage
            id="campaign_pay_it_forward.target_audience_age"
            values={{
              minAge,
              maxAge,
            }}
          />
        );
      }
      return '';
    },
    [gender, minAge, maxAge, countries, enumsCountries, showGender]
  );

  return (
    <div className="target-audience">
      <span className="target-audience__title">
        <FormattedMessage id="campaign_pay_it_forward.target_audience_title" />
      </span>
      <p className="target-audience__content">{showTargetAudience}</p>
    </div>
  );
};

TargetAudience.propTypes = {
  gender: PropTypes.string,
  minAge: PropTypes.number,
  maxAge: PropTypes.number,
  countries: PropTypes.object,
  enumsCountries: PropTypes.object,
};

export default TargetAudience;
